// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3flli","container":"styles_container__1DDc0","title":"styles_title__gPgLi","wrapper":"styles_wrapper__280nf","answer":"styles_answer__2cFMm"};